import styled from "styled-components";
import { theme } from "../../../theme";

export const FamilyMembers = styled.div`
  display: flex;
  flex: none;
  overflow: auto;
  width: 100%;
  flex-flow: row nowrap;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const MemberDetailsTile = styled.div`
  display: flex;
  flex-direction: row;
  min-width: 336px;
  border-radius: 10px;
  border: solid 1px #707070;
  background-color: #ffffff;
  margin-top: 12px;
  z-index: 10;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.16);
  margin-right: 18px;
`;

export const TileLeftBorder = styled.div`
  min-width: 24px;
  background-color: ${theme.primaryColor};
  z-index: 9;
  border-radius: 8px 0px 0px 8px;
`;

export const MemberTileContent = styled.div`
  padding: 24px 16px 6px 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const TileLeftPart = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 150px;
`;

export const TileRightPart = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TileHeading = styled.p`
  font-family: "Inter";
  font-size: 10px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.4;
  text-align: left;
  color: #4a4a4a;
  margin-bottom: 4px;
  text-transform: capitalize;
  width: 150px;
`;

export const TileHeadingText = styled.p`
  text-transform: capitalize;
  min-height: 17px;
  font-family: "Inter";
  font-size: 16px;
  font-weight: 600;
  line-height: 1.42;
  text-align: left;
  color: #4a4a4a;
  margin-bottom: 18px;
  font-family: "Inter";
`;

export const Logo = styled.img`
  object-fit: contain;
  width: auto;
  max-width: 9.2rem;
  height: 3.2rem;
  margin-bottom: 21px;
`;

export const ECardGrid = styled.section`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding: 1.4rem;
  column-gap: 2rem;
  & > div {
    word-break: break-word; // Allows long words to be broken and wrapped onto the next line
    overflow-wrap: break-word; // Ensures that if any word itself is too long, it is broken at any suitable point
    white-space: normal; // Ensures that whitespace inside the div behaves normally, allowing wrapping
    max-width: 100%; // Ensures the div does not exceed the width of the container
    hyphens: auto; // Automatically adds hyphens when breaking words
  }
`;

export const CopyContent = styled.div`
    width: inherit;
    height: 40px;
    background-color: ${theme.offwhiteColor};
    display: grid;
    grid-template-columns: 35% 57% 8%;
    justify-content: space-between;
    align-items: center;
    border-radius: 6px;
    padding: 0 1rem 0 1rem;
`

export const TitleDiv = styled.div`
  border-radius: 8px 8px 0 0;
  display: flex;
  padding: 1.5rem;
  border-bottom: 1px solid #dedde2;
    align-items: center;
    justify-content: space-between;
    
`

export const GridBox = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 1rem;
  padding: 1rem 2rem 1rem 2rem;
   > * {
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
    padding-bottom: 0.5rem; /* Optional: Adds some space below the border */
    
  }
`;

export const MainBox = styled.div`
  border-radius: 10px 10px 0px 0px;
  margin-right: 2rem;
  width: 100%;
  min-width: 346px;
  border: 1px solid #DEDDE2;

    /* Desktop view */
    @media (max-width: 400px) {
      width: 90%;
    }
  scroll-snap-align: center;
`

export const MainBoxEcard = styled.div`
  border-radius: 10px 10px 0px 0px;
  width: 100vw; /* Full width of the viewport */
  border: 1px solid #DEDDE2;

  /* Mobile view */
  @media (max-width: 400px) {
    width: 90vw; /* Adjust width for smaller screens */
  }

  scroll-snap-align: center;
`

export const GridItem = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
  background-color: #fff;
  padding: 1rem;
`;

export const Label = styled.span`
  font-size: 12px;
  font-family: 'Inter';
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Value = styled.span`
  font-size: 12px;
  font-family: 'Inter';
  font-weight: 500;
  color: rgba(74, 74, 74, 1);
  width: 86%;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
`;

export const CopyButton = styled.button`
  margin-top: 0.5rem;
  padding: 0.3rem 0.6rem;
  background-color: #eee;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;

  &:hover {
    background-color: #ddd;
  }
`;
